import { defineMessages } from 'react-intl';

export const slideBuilderMessages = defineMessages({
  removeSlideContextAria: {
    defaultMessage: 'Remove slide context',
    id: 'tQzLv6p6Y7',
    description: 'Button to stop targeting the selected slide for the next chat message',
  },
  targetThisSlideAria: {
    defaultMessage: 'Target this slide',
    id: 'MsJx/B5gOH',
    description: 'Button to apply the next chat message to the selected slide only',
  },
  changesApplyTooltip: {
    defaultMessage: 'Changes will apply to this slide only',
    id: '6qxFfMqFdq',
    description: 'Tooltip when the next chat message is scoped to one slide',
  },
  applyNextMessageTooltip: {
    defaultMessage: 'Apply your next message to this slide only',
    id: 'kUXJswdhcD',
    description: 'Tooltip inviting the user to scope the next chat message to one slide',
  },
  contextChipSlideLabel: {
    defaultMessage: 'Slide {slideNumber}',
    id: 'cp+HziItqG',
    description: 'Badge label showing which slide number is selected as chat context',
  },
  previewClickHint: {
    defaultMessage: 'Click to show where you want to describe a change',
    id: 'wnGNFrD3V6',
    description:
      'Hint shown next to the cursor when hovering a slide to place a change note',
  },
  previewImageAltSlideNumber: {
    defaultMessage: 'Slide {slideNumber}',
    id: 'DM5Y4BzPoG',
    description: 'Accessible name for slide image preview when the slide has no title',
  },
  loadingPresentation: {
    defaultMessage: 'Loading presentation…',
    id: 'PcKz9CJ/pg',
    description: 'Status text shown while the slide presentation is loading',
  },
  emptyStateNoSlides: {
    defaultMessage:
      'Use the chat to generate slides, or start with a blank presentation.',
    id: 'bXXvdSZLlI',
    description: 'Empty state when the presentation has no slides yet',
  },
  closePreview: {
    defaultMessage: 'Close preview',
    id: 'XQ2q/S5cco',
    description: 'Closes the slide builder or document preview panel',
  },
  untitledPresentation: {
    defaultMessage: 'Untitled Presentation',
    id: 'Q33Gt3Bz0j',
    description: 'Shown in the toolbar when the deck has no title yet',
  },
  renamePresentation: {
    defaultMessage: 'Rename presentation',
    id: '5+nV2H3qb3',
    description: 'Toolbar control that opens the presentation title editor',
  },
  slideCount: {
    defaultMessage: 'Slide {current} of {total}',
    id: 'TgjJVPsI2X',
    description: 'Toolbar caption showing current slide index and total slide count',
  },
  undo: {
    defaultMessage: 'Undo',
    id: 'rL8SQb5z8W',
    description: 'Toolbar control to undo the last presentation edit',
  },
  redo: {
    defaultMessage: 'Redo',
    id: '6pxTXNKQ5j',
    description: 'Toolbar control to redo a reverted presentation edit',
  },
  export: {
    defaultMessage: 'Export',
    id: 'SBh3vGsHoK',
    description: 'Toolbar control to open export format options',
  },
  exportingFormat: {
    defaultMessage: 'Exporting {format}…',
    id: 'uvSLWe/QNg',
    description:
      'Export button label while a deck is being generated; format is an uppercase file type such as PPTX or PDF',
  },
  exportPptx: {
    defaultMessage: 'PowerPoint (.pptx)',
    id: 'Q/TKhOIWjV',
    description: 'Menu item to export the presentation as a PowerPoint file',
  },
  exportPdf: {
    defaultMessage: 'PDF (.pdf)',
    id: '38Ycqo1Jn7',
    description: 'Menu item to export the presentation as a PDF file',
  },
  annotationPlaceholder: {
    defaultMessage: 'Tell us what to change...',
    id: '6bfbrHenj5',
    description:
      'Placeholder in the slide annotation input before the user describes edits',
  },
});
